import type { $Fetch } from 'nitropack'

let cachedFetch: $Fetch | null = null

// Base Strapi v5 client. Attaches readonly token, prepends /api.
// Token is exposed to the client by design — see docs/architecture decision.
export const useStrapiFetch = (): $Fetch => {
  if (cachedFetch) return cachedFetch

  const { strapi } = useRuntimeConfig().public

  cachedFetch = $fetch.create({
    baseURL: `${strapi.url}/api`,
    headers: strapi.token
      ? { Authorization: `Bearer ${strapi.token}` }
      : {},
  })

  return cachedFetch
}